import { Component, Element, Prop, h } from '@stencil/core';

import { onStateFieldAnswered } from '../../../actions/actions.answers';
import { AnswerVehicle, VehicleOption } from '../../../interfaces/interface.vehicle';
import { VehicleConfigState } from '../../../store/store.vehicle-config';

@Component({
  tag: 'vehicle-ted',
  styleUrl: 'vehicle-ted.css',
})
export class VehicleTed {
  @Element() el: HTMLElement;

  @Prop() vehicleConfig: VehicleConfigState;
  @Prop() vehicleAnswers: AnswerVehicle;

  setSelectedEngine(engine: VehicleOption) {
    if (engine) {
      const { displayName, optionId } = engine;
      onStateFieldAnswered('vehicle', 'engineId', optionId);
      onStateFieldAnswered('vehicle', 'engine', displayName);
    }
  }

  setSelectedTransmission(transmission: VehicleOption) {
    if (transmission) {
      const { displayName, optionId } = transmission;
      onStateFieldAnswered('vehicle', 'transmissionId', optionId);
      onStateFieldAnswered('vehicle', 'transmission', displayName);
    }
  }

  setSelectedDrivetrain(drivetrain) {
    if (drivetrain) {
      const { displayName, optionId } = drivetrain;
      onStateFieldAnswered('vehicle', 'drivetrainId', optionId);
      onStateFieldAnswered('vehicle', 'drivetrain', displayName);
    }
  }

  renderEngines(availEngines) {
    const engines = availEngines.map((e) => (
      <input-rounded-button
        class="xs:w-full sm:w-auto"
        label={e.displayName}
        name={e.optionId}
        buttonId={e.optionId}
        selected={this.vehicleAnswers.engineId === e.optionId}
        whenClicked={() => this.setSelectedEngine(e)}
        caption={e.isDefault ? 'Most Common' : ''}
      />
    ));
    return (
      <div>
        <div class="vehicle-ted__subheader">Engine</div>
        <div class="vehicle-ted__options-container">{engines}</div>
      </div>
    );
  }

  renderTransmission(availTransmissions) {
    const transmissions = availTransmissions.map((t) => (
      <input-rounded-button
        class="xs:w-full sm:w-auto"
        label={t.displayName}
        name={t.optionId}
        buttonId={t.optionId}
        selected={this.vehicleAnswers.transmissionId === t.optionId}
        whenClicked={() => this.setSelectedTransmission(t)}
        caption={t.isDefault ? 'Most Common' : ''}
      />
    ));
    return (
      <div>
        <div class="vehicle-ted__subheader">Transmission</div>
        <div class="vehicle-ted__options-container">{transmissions}</div>
      </div>
    );
  }

  renderDrivetrain(availDrivetrains) {
    const drivetrains = availDrivetrains.map((d) => (
      <input-square-button
        class="xs:w-full sm:w-auto"
        label={d.displayName}
        size="large"
        id={d.optionId}
        onClick={() => this.setSelectedDrivetrain(d)}
        isActive={this.vehicleAnswers.drivetrainId === d.optionId}
        caption={d.isDefault ? 'Most Common' : ''}
        disableCenter={true}>
        <svg-icon icon={`config-drivetrain-${d.displayName.toLocaleLowerCase()}`} />
      </input-square-button>
    ));
    return (
      <div>
        <div class="vehicle-ted__subheader">Drivetrain</div>
        <div class="vehicle-ted__options-container">{drivetrains}</div>
      </div>
    );
  }

  render() {
    const { featuredEngine, featuredDrivetrain, featuredTransmission, availEngines, availDrivetrains, availTransmissions } = this.vehicleConfig;
    return (
      <box-shadow>
        <h2 class="ico-components-heading-large mb-2">What's Under the Hood?</h2>
        <div>{!featuredEngine && this.renderEngines(availEngines)}</div>
        <div>{!featuredTransmission && this.renderTransmission(availTransmissions)}</div>
        <div>{!featuredDrivetrain && this.renderDrivetrain(availDrivetrains)}</div>
      </box-shadow>
    );
  }
}
